//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      showSnackbar: false,
      msg: "",
      buttonText: "",
      callback: null,
      closeOnClick: false,
    };
  },
  methods: {
    action() {
      if (this.closeOnClick) this.showSnackbar = false;
      return this.callback();
    },
  },
  mounted() {
    this.$root.$on("snackbar", (data) => {
      this.showSnackbar = true;
      this.msg = data.msg;
      this.buttonText = data.buttonText;
      this.callback = data.callback;
      this.closeOnClick = data.closeOnClick;
    });
  },
};
